import React from "react";

import { Icon, IconProps } from "../";

export const FileZipIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.64776 5.64956L3.64956 5.64775C3.76176 5.53536 3.85143 5.5 4 5.5H9.175C9.24855 5.5 9.30776 5.51268 9.36448 5.53602C9.42496 5.56118 9.47148 5.5928 9.51434 5.63566L11.3787 7.5H20C20.1486 7.5 20.2391 7.53545 20.3523 7.64866C20.4643 7.76066 20.5 7.85061 20.5 8V18C20.5 18.149 20.4645 18.2397 20.3524 18.3522C20.2398 18.4644 20.1491 18.5 20 18.5H4C3.85062 18.5 3.76067 18.4643 3.64866 18.3523C3.53545 18.2391 3.5 18.1486 3.5 18V6C3.5 5.85143 3.53537 5.76176 3.64776 5.64956ZM9.175 4C9.44167 4 9.696 4.04999 9.938 4.14999C10.1793 4.24999 10.3917 4.39166 10.575 4.575L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.8043 6.97933 22 7.45 22 8V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4C3.45 20 2.97933 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.97933 4.196 3.45 4 4 4H9.175ZM16 8H14V10H16V12H14V14H16V16H14V18H16V16H18V14H16V12H18V10H16V8Z"
      />
    </Icon>
  );
};
